import { keys, pick } from 'lodash';
import {
  extractParams,
  getCookie,
  isBrowser,
  setCookie,
} from '@zapier/common-utils';
import TrackingConstants from './constants';
const TrackingCookies = {
  retrieveGclid() {
    const gclidCookie = getCookie(TrackingConstants.GCLID_COOKIE_NAME);

    if (gclidCookie) {
      try {
        return atob(decodeURIComponent(gclidCookie));
      } catch (e) {
        console.error(`Error retrieving gclid: ${e}`);
      }
    }

    return undefined;
  },

  storeGclid(href: string = window.location.href) {
    if (isBrowser()) {
      const params = extractParams(href);
      const gclidParam = params.gclid;

      if (gclidParam) {
        setCookie(
          TrackingConstants.GCLID_COOKIE_NAME,
          encodeURIComponent(btoa(gclidParam)),
          TrackingConstants.GCLID_COOKIE_EXPIRATION
        );
      }
    }
  },

  retrieveFbclid() {
    const fbclidCookie = getCookie(TrackingConstants.FBCLID_COOKIE_NAME);

    if (fbclidCookie) {
      try {
        return atob(decodeURIComponent(fbclidCookie));
      } catch (e) {
        console.error(`Error retrieving fbclid: ${e}`);
      }
    }

    return undefined;
  },

  storeFbclid(href: string = window.location.href) {
    if (isBrowser()) {
      const params = extractParams(href);
      const fbclidParam = params.fbclid;

      if (fbclidParam) {
        setCookie(
          TrackingConstants.FBCLID_COOKIE_NAME,
          encodeURIComponent(btoa(fbclidParam)),
          TrackingConstants.FBCLID_COOKIE_EXPIRATION
        );
      }
    }
  },

  retrieveUtms() {
    if (isBrowser()) {
      const utmCookie = getCookie(TrackingConstants.UTM_COOKIE_NAME);

      if (utmCookie) {
        try {
          return JSON.parse(utmCookie);
        } catch (e) {
          // If we fail to parse the cookie, then we will resolve everything
          // as `undefined`.
        }
      }
    }

    return {
      utm_campaign: undefined,
      utm_source: undefined,
      utm_content: undefined,
      utm_medium: undefined,
    };
  },

  retrieveUserIdentity() {
    const userIdentityCookie = getCookie(
      TrackingConstants.USER_IDENTITY_COOKIE_NAME
    );

    if (userIdentityCookie) {
      try {
        const rawCookie = atob(decodeURIComponent(userIdentityCookie));
        const parsedCookie = JSON.parse(rawCookie);
        return {
          email: parsedCookie.email,
          signupType: parsedCookie.signup_type,
        };
      } catch (e) {
        // If we fail to parse the cookie, then we will resolve everything
        // as `null`.
      }
    }

    return {
      email: null,
      signupType: null,
    };
  },

  clearUserIdentity() {
    setCookie(TrackingConstants.USER_IDENTITY_COOKIE_NAME, '', 1);
  },

  storeUtms(url?: string) {
    if (isBrowser()) {
      try {
        const href = url || window.location.href;
        const params = extractParams(href);
        const utmParams = pick(params, TrackingConstants.UTM_PARAM_NAMES);

        if (keys(utmParams).length > 0) {
          setCookie(
            TrackingConstants.UTM_COOKIE_NAME,
            JSON.stringify(utmParams),
            TrackingConstants.UTM_COOKIE_EXPIRATION
          );
        }

        return undefined;
      } catch (e) {
        // If we fail to set the cookie, then we will resolve `undefined`.
      }
    }

    return undefined;
  },
};
export default TrackingCookies;
